import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import CommonPagination from './components/CommonPagination.vue'
import { cleanupLegacyVerifyMockData } from './utils/legacyVerifyMockCleanup'

const ignoredResizeObserverMessages = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded'
]

// Suppress noisy browser ResizeObserver warnings from the dev overlay on resize/zoom.
window.addEventListener(
  'error',
  (event) => {
    if (ignoredResizeObserverMessages.includes(event.message)) {
      event.stopImmediatePropagation()
    }
  },
  true
)

const pinia = createPinia()
const app = createApp(App)
cleanupLegacyVerifyMockData()
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.component('CommonPagination', CommonPagination)
app.use(pinia).use(ElementPlus, { locale: zhCn }).use(router).mount('#app')
